import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { NctsPhase, NctsScope } from '../../../../shared/ncts/types'
import { validateTransitOperation } from '../../transit-operation/api/validateTransitOperation'

function useValidateDeclarationQuery(transitOperationId: number | null, params: {
  phase: NctsPhase
  scope: NctsScope
  houseConsignmentId?: number
  consignmentItemId?: number
  isOptIn?: boolean
}, opts?: {
  enabled?: boolean
}) {
  const isInternallyEnabled = !!transitOperationId && ((params.scope !== 'houseConsignment' && params.scope !== 'consignmentItem')
      || !!params.houseConsignmentId
      || !!params.consignmentItemId)

  const isEnabled = (opts?.enabled ?? true) && isInternallyEnabled
  return useQuery({
    queryKey: QueryKeys.transitOperation.validation({ transitOperationId, params }),
    enabled: isEnabled,
    queryFn: () => validateTransitOperation(transitOperationId as number, params),
    staleTime: 0,
  })
}

export default useValidateDeclarationQuery
